import "./repo.a5e9c946.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecaa2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecaa2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lsboS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9e50e5a44fb11e0$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $f9e50e5a44fb11e0$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ArrowRight", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
]);

});

parcelRegister("gn8IX", function(module, exports) {

$parcel$export(module.exports, "default", () => $beb58fc2118025b6$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $beb58fc2118025b6$export$2e2bcd8739ae039 = (0, $b4WUK.default)("CalendarDays", [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ],
    [
        "path",
        {
            d: "M8 14h.01",
            key: "6423bh"
        }
    ],
    [
        "path",
        {
            d: "M12 14h.01",
            key: "1etili"
        }
    ],
    [
        "path",
        {
            d: "M16 14h.01",
            key: "1gbofw"
        }
    ],
    [
        "path",
        {
            d: "M8 18h.01",
            key: "lrp35t"
        }
    ],
    [
        "path",
        {
            d: "M12 18h.01",
            key: "mhygvu"
        }
    ],
    [
        "path",
        {
            d: "M16 18h.01",
            key: "kzsmim"
        }
    ]
]);

});

parcelRegister("ki04U", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec558c98a508af21$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $ec558c98a508af21$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Clock3", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "polyline",
        {
            points: "12 6 12 12 16.5 12",
            key: "1aq6pp"
        }
    ]
]);

});

parcelRegister("8Z597", function(module, exports) {

$parcel$export(module.exports, "default", () => $68a8032150568403$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $68a8032150568403$export$2e2bcd8739ae039 = (0, $b4WUK.default)("HandHeart", [
    [
        "path",
        {
            d: "M11 14h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16",
            key: "1ifwr1"
        }
    ],
    [
        "path",
        {
            d: "m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
            key: "17abbs"
        }
    ],
    [
        "path",
        {
            d: "m2 15 6 6",
            key: "10dquu"
        }
    ],
    [
        "path",
        {
            d: "M19.5 8.5c.7-.7 1.5-1.6 1.5-2.7A2.73 2.73 0 0 0 16 4a2.78 2.78 0 0 0-5 1.8c0 1.2.8 2 1.5 2.8L16 12Z",
            key: "1h3036"
        }
    ]
]);

});

parcelRegister("8dk79", function(module, exports) {

$parcel$export(module.exports, "default", () => $5faf23ec0b8e3e8e$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $5faf23ec0b8e3e8e$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Sparkles", [
    [
        "path",
        {
            d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
            key: "4pj2yx"
        }
    ],
    [
        "path",
        {
            d: "M20 3v4",
            key: "1olli1"
        }
    ],
    [
        "path",
        {
            d: "M22 5h-4",
            key: "1gvqau"
        }
    ],
    [
        "path",
        {
            d: "M4 17v2",
            key: "vumght"
        }
    ],
    [
        "path",
        {
            d: "M5 18H3",
            key: "zchphs"
        }
    ]
]);

});

parcelRegister("azpgp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b20c5205e441d74$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $7b20c5205e441d74$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ArrowLeft", [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
]);

});

parcelRegister("ced6i", function(module, exports) {

$parcel$export(module.exports, "EventCover", () => $e5ba17c63bc0e4da$export$10ca8b5adb16b591);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c91it = parcelRequire("c91it");
function $e5ba17c63bc0e4da$export$10ca8b5adb16b591({ src: src, className: className = '', fallback: fallback, children: children, onAvailability: onAvailability }) {
    const sources = src ? (0, $c91it.expandImageSources)(src) : [];
    const [index, setIndex] = (0, $acw62.useState)(0);
    const current = sources[index];
    if (!current) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `${className} is-fallback`,
        children: [
            fallback,
            children
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: current,
                alt: "",
                loading: "lazy",
                onLoad: ()=>onAvailability?.(true),
                onError: ()=>{
                    const next = index + 1;
                    if (next >= sources.length) onAvailability?.(false);
                    setIndex(next);
                }
            }),
            children
        ]
    });
}

});

parcelRegister("dSNXT", function(module, exports) {

$parcel$export(module.exports, "RecurrenceBadge", () => $760f5631e1d6e874$export$bf031ef5546a1292);
$parcel$export(module.exports, "RegistrationBadge", () => $760f5631e1d6e874$export$6aa4bebb1f9a7d61);
$parcel$export(module.exports, "EventPeople", () => $760f5631e1d6e874$export$dc2c6f01e73f82f);

var $ayMG0 = parcelRequire("ayMG0");

var $4JXUu = parcelRequire("4JXUu");
var $9eJBK = parcelRequire("9eJBK");

var $c91it = parcelRequire("c91it");
function $760f5631e1d6e874$export$bf031ef5546a1292({ event: event }) {
    if (!event.recurring) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: "event-recurrence-badge",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9eJBK.default), {
                size: 14,
                "aria-hidden": "true"
            }),
            "Recurrente",
            event.recurrenceLabel ? ` \xb7 ${event.recurrenceLabel}` : ''
        ]
    });
}
function $760f5631e1d6e874$export$6aa4bebb1f9a7d61({ event: event }) {
    if (!event.registrationUrl) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: "event-register-badge",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4JXUu.default), {
                size: 14,
                "aria-hidden": "true"
            }),
            "Requiere inscripci\xf3n"
        ]
    });
}
function $760f5631e1d6e874$var$PeopleGroup({ names: names, label: label, variant: variant }) {
    if (!names.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `event-people-group is-${variant}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                children: names.map((name)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-hidden": "true",
                                children: (0, $c91it.personInitials)(name)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: name
                            })
                        ]
                    }, `${variant}-${name}`))
            })
        ]
    });
}
function $760f5631e1d6e874$export$dc2c6f01e73f82f({ event: event }) {
    if (!event.organizers.length && !event.guests.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "event-people",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($760f5631e1d6e874$var$PeopleGroup, {
                names: event.organizers,
                label: event.organizers.length > 1 ? 'Organizan' : 'Organiza',
                variant: "organizer"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($760f5631e1d6e874$var$PeopleGroup, {
                names: event.guests,
                label: event.guests.length > 1 ? 'Invitados' : 'Invitado',
                variant: "guest"
            })
        ]
    });
}

});
parcelRegister("4JXUu", function(module, exports) {

$parcel$export(module.exports, "default", () => $3739d64fb7ddfae6$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $3739d64fb7ddfae6$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ClipboardList", [
    [
        "rect",
        {
            width: "8",
            height: "4",
            x: "8",
            y: "2",
            rx: "1",
            ry: "1",
            key: "tgr4d6"
        }
    ],
    [
        "path",
        {
            d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
            key: "116196"
        }
    ],
    [
        "path",
        {
            d: "M12 11h4",
            key: "1jrz19"
        }
    ],
    [
        "path",
        {
            d: "M12 16h4",
            key: "n85exb"
        }
    ],
    [
        "path",
        {
            d: "M8 11h.01",
            key: "1dfujw"
        }
    ],
    [
        "path",
        {
            d: "M8 16h.01",
            key: "18s6g9"
        }
    ]
]);

});

parcelRegister("9eJBK", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b98cc9f5dadc552$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $6b98cc9f5dadc552$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Repeat", [
    [
        "path",
        {
            d: "m17 2 4 4-4 4",
            key: "nntrym"
        }
    ],
    [
        "path",
        {
            d: "M3 11v-1a4 4 0 0 1 4-4h14",
            key: "84bu3i"
        }
    ],
    [
        "path",
        {
            d: "m7 22-4-4 4-4",
            key: "1wqhfi"
        }
    ],
    [
        "path",
        {
            d: "M21 13v1a4 4 0 0 1-4 4H3",
            key: "1rx37r"
        }
    ]
]);

});



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");

var $ayMG0 = parcelRequire("ayMG0");

var $lsboS = parcelRequire("lsboS");
var $03hdr = parcelRequire("03hdr");
var $gn8IX = parcelRequire("gn8IX");/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $de4f65978d6df592$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Church", [
    [
        "path",
        {
            d: "M10 9h4",
            key: "u4k05v"
        }
    ],
    [
        "path",
        {
            d: "M12 7v5",
            key: "ma6bk"
        }
    ],
    [
        "path",
        {
            d: "M14 22v-4a2 2 0 0 0-4 0v4",
            key: "1pdhuj"
        }
    ],
    [
        "path",
        {
            d: "M18 22V5.618a1 1 0 0 0-.553-.894l-4.553-2.277a2 2 0 0 0-1.788 0L6.553 4.724A1 1 0 0 0 6 5.618V22",
            key: "1rkokr"
        }
    ],
    [
        "path",
        {
            d: "m18 7 3.447 1.724a1 1 0 0 1 .553.894V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.618a1 1 0 0 1 .553-.894L6 7",
            key: "1w6esw"
        }
    ]
]);


var $ki04U = parcelRequire("ki04U");
var $voOPz = parcelRequire("voOPz");
var $8Z597 = parcelRequire("8Z597");
var $7RdtG = parcelRequire("7RdtG");
var $hipFw = parcelRequire("hipFw");/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $9e53861a3b8693f4$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Music2", [
    [
        "circle",
        {
            cx: "8",
            cy: "18",
            r: "4",
            key: "1fc0mg"
        }
    ],
    [
        "path",
        {
            d: "M12 18V2l7 4",
            key: "g04rme"
        }
    ]
]);


var $8dk79 = parcelRequire("8dk79");/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $26e74a24e9f2bb34$export$2e2bcd8739ae039 = (0, $b4WUK.default)("UsersRound", [
    [
        "path",
        {
            d: "M18 21a8 8 0 0 0-16 0",
            key: "3ypg7q"
        }
    ],
    [
        "circle",
        {
            cx: "10",
            cy: "8",
            r: "5",
            key: "o932ke"
        }
    ],
    [
        "path",
        {
            d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3",
            key: "10s06x"
        }
    ]
]);



var $clpju = parcelRequire("clpju");

var $5xqgC = parcelRequire("5xqgC");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $azpgp = parcelRequire("azpgp");
var $lsboS = parcelRequire("lsboS");
var $ki04U = parcelRequire("ki04U");
var $hipFw = parcelRequire("hipFw");

var $c91it = parcelRequire("c91it");

var $ced6i = parcelRequire("ced6i");

var $dSNXT = parcelRequire("dSNXT");
function $55f764e04346b51e$export$f80192e707809cb9({ events: events }) {
    const trackRef = (0, $acw62.useRef)(null);
    const [index, setIndex] = (0, $acw62.useState)(0);
    const [paused, setPaused] = (0, $acw62.useState)(false);
    const slides = events.slice(0, 8);
    (0, $acw62.useEffect)(()=>{
        const track = trackRef.current;
        if (!track) return;
        const update = ()=>{
            const width = track.clientWidth || 1;
            setIndex(Math.round(track.scrollLeft / width));
        };
        track.addEventListener('scroll', update, {
            passive: true
        });
        return ()=>track.removeEventListener('scroll', update);
    }, [
        slides.length
    ]);
    (0, $acw62.useEffect)(()=>{
        if (slides.length < 2 || paused) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const timer = window.setInterval(()=>{
            const track = trackRef.current;
            if (!track) return;
            const next = (index + 1) % slides.length;
            track.scrollTo({
                left: next * track.clientWidth,
                behavior: 'smooth'
            });
        }, 7000);
        return ()=>window.clearInterval(timer);
    }, [
        index,
        paused,
        slides.length
    ]);
    const goTo = (target)=>{
        const track = trackRef.current;
        if (!track) return;
        const next = (target + slides.length) % slides.length;
        track.scrollTo({
            left: next * track.clientWidth,
            behavior: 'smooth'
        });
    };
    if (!slides.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "events-slider reveal",
        onMouseEnter: ()=>setPaused(true),
        onMouseLeave: ()=>setPaused(false),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "events-slider-viewport",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "events-slider-track",
                    ref: trackRef,
                    tabIndex: 0,
                    "aria-label": "Pr\xf3ximos eventos",
                    children: slides.map((event, slideIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)($55f764e04346b51e$var$EventSlide, {
                            event: event,
                            active: slideIndex === index
                        }, `${event.uid}-${event.start.toISOString()}`))
                })
            }),
            slides.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "events-slider-controls",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                className: "events-slider-arrow",
                                onClick: ()=>goTo(index - 1),
                                "aria-label": "Evento anterior",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $azpgp.default), {
                                    size: 18,
                                    "aria-hidden": "true"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                className: "events-slider-arrow",
                                onClick: ()=>goTo(index + 1),
                                "aria-label": "Evento siguiente",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lsboS.default), {
                                    size: 18,
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "events-slider-dots",
                        role: "tablist",
                        "aria-label": "Elegir evento",
                        children: slides.map((event, slideIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                role: "tab",
                                "aria-selected": slideIndex === index,
                                "aria-label": `Ir al evento ${slideIndex + 1}`,
                                className: slideIndex === index ? 'is-active' : '',
                                onClick: ()=>goTo(slideIndex)
                            }, `${event.uid}-dot`))
                    })
                ]
            })
        ]
    });
}
function $55f764e04346b51e$var$EventSlide({ event: event, active: active }) {
    const date = (0, $c91it.formatEventCardDate)(event);
    const cover = event.images[0];
    const href = (0, $c91it.eventDetailHref)(event);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("article", {
        className: `events-slide ${cover ? '' : 'is-fallback'}`,
        "aria-hidden": !active,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ced6i.EventCover), {
                src: cover,
                className: "events-slide-media",
                fallback: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "events-slide-orb"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "events-slide-overlay"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "events-slide-copy",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("time", {
                        className: "event-date-badge event-date-badge-lg",
                        dateTime: event.start.toISOString(),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: date.day
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: date.month
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dSNXT.RecurrenceBadge), {
                        event: event
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dSNXT.RegistrationBadge), {
                        event: event
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "events-slide-kicker",
                        children: [
                            date.weekday,
                            " \xb7 ",
                            date.time
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: event.title
                    }),
                    event.excerpt && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "events-slide-excerpt",
                        children: event.excerpt
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                        className: "events-slide-facts",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ki04U.default), {
                                        size: 17,
                                        "aria-hidden": "true"
                                    }),
                                    date.longDate
                                ]
                            }),
                            event.location && /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hipFw.default), {
                                        size: 17,
                                        "aria-hidden": "true"
                                    }),
                                    event.location
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                        className: "button button-gold",
                        href: href,
                        children: [
                            "Ver detalles ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lsboS.default), {
                                size: 18,
                                "aria-hidden": "true"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $3ua1s = parcelRequire("3ua1s");

var $gb7Gf = parcelRequire("gb7Gf");
const $9aecac4636d85589$var$ministries = [
    {
        icon: (0, $9e53861a3b8693f4$export$2e2bcd8739ae039),
        image: (0, $clpju.imgAdoracion),
        alt: "Ministerio de adoraci\xf3n de Tercer Cielo durante un servicio",
        title: "Adoraci\xf3n",
        text: 'Un equipo que levanta la alabanza y prepara el ambiente para encontrarnos con Dios.',
        tag: 'Cada servicio'
    },
    {
        icon: (0, $8Z597.default),
        image: (0, $clpju.imgAlcanceCalles),
        imagePosition: 'center 16%',
        alt: 'Miembros de Tercer Cielo compartiendo el mensaje en la calle',
        title: 'Alcance',
        text: "Salimos a las calles de Ju\xe1rez a orar, abrazar y compartir la esperanza de Jes\xfas.",
        tag: 'En la ciudad'
    }
];
const $9aecac4636d85589$var$galleryItems = [
    {
        image: (0, $clpju.imgCongregacionWide),
        alt: "Congregaci\xf3n reunida bajo el techo iluminado de la iglesia",
        caption: 'Una casa que crece',
        className: 'gallery-feature'
    },
    {
        image: (0, $clpju.imgCongregacion),
        alt: 'Comunidad de Tercer Cielo reunida en el auditorio',
        caption: 'Fe en familia',
        className: 'gallery-tall'
    },
    {
        image: (0, $clpju.imgAlcanceOracion),
        alt: "La congregaci\xf3n compartiendo y orando juntos al aire libre",
        caption: "Compartimos a Jes\xfas",
        className: 'gallery-small'
    },
    {
        image: (0, $clpju.imgAlcanceCartel),
        alt: "J\xf3venes con un cartel de esperanza: \u201CEn la tormenta, \xc9l calma el mar de tu coraz\xf3n\u201D",
        caption: 'Esperanza en la calle',
        className: 'gallery-small'
    }
];
function $9aecac4636d85589$var$NextServiceChip() {
    const next = (0, $3ua1s.useNextService)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
        className: "hero-next-service",
        href: "/visita/",
        "aria-label": "Ver detalles de la visita",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "pulse-dot",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "next-service-text",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("small", {
                        children: [
                            "Pr\xf3ximo encuentro \xb7 ",
                            next.when
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                        children: [
                            next.service.day,
                            " ",
                            next.service.time,
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("em", {
                                children: [
                                    "\xb7 en ",
                                    next.countdown
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03hdr.default), {
                size: 18,
                "aria-hidden": "true"
            })
        ]
    });
}
function $9aecac4636d85589$var$Hero() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "hero",
        "aria-labelledby": "hero-title",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "hero-media",
                style: {
                    backgroundImage: `url(${(0, $clpju.heroPoster)})`
                },
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("video", {
                        src: (0, $clpju.heroVideo),
                        poster: (0, $clpju.heroPoster),
                        autoPlay: true,
                        muted: true,
                        loop: true,
                        playsInline: true,
                        preload: "metadata"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "hero-overlay"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "page-shell hero-content",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "eyebrow eyebrow-light reveal is-visible",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-hidden": "true"
                            }),
                            " Iglesia Cristiana \xb7 Ciudad Ju\xe1rez"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                        id: "hero-title",
                        className: "reveal is-visible",
                        children: [
                            "Un lugar para encontrarte ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                                children: "con Dios"
                            }),
                            " y con prop\xf3sito."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "hero-lead reveal is-visible",
                        children: "Somos una comunidad que crece en fe, vive en familia y comparte a Jes\xfas. Aqu\xed hay un lugar para ti."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "hero-actions reveal is-visible",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                className: "button button-gold",
                                href: "/visita/",
                                children: [
                                    "Planifica tu visita ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lsboS.default), {
                                        size: 18,
                                        "aria-hidden": "true"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                className: "button button-ghost",
                                href: (0, $gb7Gf.facebookUrl),
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $voOPz.default), {
                                        size: 18,
                                        "aria-hidden": "true"
                                    }),
                                    " M\xedranos en Facebook"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "hero-extra reveal is-visible",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($9aecac4636d85589$var$NextServiceChip, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "hero-scroll-cue",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "Desliza"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {})
                ]
            })
        ]
    });
}
function $9aecac4636d85589$var$VerseStrip() {
    const phrase = 'Por un avivamiento del cielo en los corazones';
    const repetitions = Array.from({
        length: 6
    }, (_, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            "aria-hidden": index > 0,
            children: [
                phrase,
                " ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8dk79.default), {
                    size: 16,
                    "aria-hidden": "true"
                })
            ]
        }, index));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "verse-strip",
        "aria-label": phrase,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "verse-strip-track",
            children: repetitions
        })
    });
}
function $9aecac4636d85589$var$ServicesSection() {
    const next = (0, $3ua1s.useNextService)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "services-section section-space",
        "aria-labelledby": "services-title",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "page-shell",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "section-heading services-heading reveal",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "section-kicker",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                        " Nos reunimos cada semana"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    id: "services-title",
                                    children: "Hay un encuentro para ti."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                            className: "text-link",
                            href: (0, $gb7Gf.mapUrl),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: [
                                "C\xf3mo llegar ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03hdr.default), {
                                    size: 17,
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "services-grid",
                    children: (0, $gb7Gf.services).map((service, index)=>{
                        const isNext = service === next.service;
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("article", {
                            className: `service-card reveal ${isNext ? 'is-next' : ''}`,
                            children: [
                                isNext && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "service-next-badge",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "pulse-dot",
                                            "aria-hidden": "true"
                                        }),
                                        " Siguiente \xb7 ",
                                        next.countdown
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "service-number",
                                    children: [
                                        "0",
                                        index + 1
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "service-day",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "status-dot",
                                            "aria-hidden": "true"
                                        }),
                                        service.day
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("time", {
                                    children: service.time
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: service.title
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    children: service.note
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "service-icon",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ki04U.default), {
                                        size: 19
                                    })
                                })
                            ]
                        }, `${service.day}-${service.time}`);
                    })
                })
            ]
        })
    });
}
function $9aecac4636d85589$var$EventsSection() {
    const { events: events, status: status } = (0, $3ua1s.useEvents)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "events-home-section section-space",
        "aria-labelledby": "events-home-title",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "page-shell",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "section-heading reveal",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "section-kicker",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                        " Agenda de la casa"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    id: "events-home-title",
                                    children: "Pr\xf3ximos eventos."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                            className: "text-link",
                            href: "/eventos/",
                            children: [
                                "Ver todos ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03hdr.default), {
                                    size: 17,
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    ]
                }),
                status === 'loading' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "events-empty reveal",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gn8IX.default), {
                            size: 28,
                            "aria-hidden": "true"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "Cargando la agenda\u2026"
                        })
                    ]
                }),
                status === 'error' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "events-empty reveal",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gn8IX.default), {
                            size: 28,
                            "aria-hidden": "true"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "No pudimos cargar los eventos en este momento."
                        })
                    ]
                }),
                status === 'ready' && events.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "events-empty reveal",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gn8IX.default), {
                            size: 28,
                            "aria-hidden": "true"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "Pronto anunciaremos nuevos eventos. Te esperamos en nuestros servicios semanales."
                        })
                    ]
                }),
                status === 'ready' && events.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $55f764e04346b51e$export$f80192e707809cb9), {
                    events: events
                })
            ]
        })
    });
}
function $9aecac4636d85589$var$MinistriesSection() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "ministries-section section-space",
        "aria-labelledby": "ministries-title",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "page-shell",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "section-heading reveal",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "section-kicker",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                        " La casa late fuerte"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    id: "ministries-title",
                                    children: "Ministerios con vida."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "Cada semana la iglesia se enciende: adoraci\xf3n, ministraci\xf3n y una familia que sale a compartir lo que ha recibido."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "ministries-grid",
                    children: $9aecac4636d85589$var$ministries.map(({ icon: Icon, image: image, imagePosition: imagePosition, alt: alt, title: title, text: text, tag: tag })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("article", {
                            className: "ministry-card reveal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "ministry-image",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: image,
                                            alt: alt,
                                            loading: "lazy",
                                            style: imagePosition ? {
                                                objectPosition: imagePosition
                                            } : undefined
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "ministry-tag",
                                            children: tag
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "ministry-body",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "ministry-icon",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                                                size: 22,
                                                "aria-hidden": "true"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: text
                                        })
                                    ]
                                })
                            ]
                        }, title))
                })
            ]
        })
    });
}
function $9aecac4636d85589$var$PastorsSection() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "pastors-section section-space",
        "aria-labelledby": "pastors-title",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "page-shell pastors-card reveal",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pastors-image-wrap",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (0, $clpju.imgPastores),
                            alt: "Los pastores Diana y Fernando Renter\xeda orando junto a la congregaci\xf3n",
                            loading: "lazy"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pastors-image-tag",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $de4f65978d6df592$export$2e2bcd8739ae039), {
                                    size: 18,
                                    "aria-hidden": "true"
                                }),
                                " Sirviendo a Ciudad Ju\xe1rez"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pastors-copy",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "section-kicker section-kicker-light",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                " Nuestros pastores"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            id: "pastors-title",
                            children: "Liderando con fe, servicio y cercan\xeda."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "pastors-names",
                            children: [
                                "Diana ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "&"
                                }),
                                " Fernando Renter\xeda"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "pastors-message",
                            children: "Nuestro deseo es que cada persona encuentre un espacio para acercarse a Dios, crecer en su Palabra y construir relaciones con prop\xf3sito."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pastors-quote",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8dk79.default), {
                                    size: 20,
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "\u201CPor un avivamiento del cielo en los corazones.\u201D"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $9aecac4636d85589$var$GallerySection() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "gallery-section section-space",
        "aria-labelledby": "gallery-title",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "page-shell",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "section-heading reveal",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "section-kicker",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                        " Nuestra comunidad"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    id: "gallery-title",
                                    children: "La fe tambi\xe9n se vive acompa\xf1ados."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "Oramos, servimos y compartimos el mensaje de Jes\xfas como una familia que hace espacio para cada persona."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "gallery-grid",
                    children: [
                        $9aecac4636d85589$var$galleryItems.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("figure", {
                                className: `gallery-item reveal ${item.className}`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: item.image,
                                        alt: item.alt,
                                        loading: "lazy"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("figcaption", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    "0",
                                                    index + 1
                                                ]
                                            }),
                                            " ",
                                            item.caption
                                        ]
                                    })
                                ]
                            }, item.caption)),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "gallery-statement reveal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "statement-icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26e74a24e9f2bb34$export$2e2bcd8739ae039), {
                                        size: 24,
                                        "aria-hidden": "true"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "Una comunidad que escucha, acompa\xf1a y sirve."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    href: (0, $gb7Gf.instagramUrl),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: [
                                        "Ver m\xe1s en Instagram ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03hdr.default), {
                                            size: 17,
                                            "aria-hidden": "true"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $9aecac4636d85589$var$SocialCtaSection() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "social-section",
        "aria-labelledby": "social-title",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "page-shell social-layout",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "social-copy reveal",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "section-kicker section-kicker-light",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                " Con\xe9ctate con nosotros"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            id: "social-title",
                            children: "La iglesia, tambi\xe9n en tu pantalla."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "S\xedguenos en Facebook para ver las transmisiones de los servicios, los anuncios de la semana y lo que Dios est\xe1 haciendo en la casa."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "social-cards",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                            className: "social-card social-card-facebook reveal",
                            href: (0, $gb7Gf.facebookUrl),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "social-card-icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $voOPz.default), {
                                        size: 26,
                                        "aria-hidden": "true"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "Facebook"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: "Transmisiones en vivo y mensajes recientes."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03hdr.default), {
                                    size: 20,
                                    "aria-hidden": "true"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                            className: "social-card social-card-instagram reveal",
                            href: (0, $gb7Gf.instagramUrl),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "social-card-icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7RdtG.default), {
                                        size: 26,
                                        "aria-hidden": "true"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "Instagram"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: "El d\xeda a d\xeda de la comunidad, en fotos."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03hdr.default), {
                                    size: 20,
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $9aecac4636d85589$var$VisitSection() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "visit-section section-space",
        "aria-labelledby": "visit-title",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "visit-orb",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "page-shell visit-layout",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "visit-copy reveal",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "section-kicker section-kicker-light",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                    " Planea tu visita"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                id: "visit-title",
                                children: "Nos encantar\xe1 conocerte."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Guarda nuestros horarios, abre la ubicaci\xf3n y ven a compartir con nosotros. Aqu\xed hay un lugar para ti."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "visit-actions",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                        className: "button button-light",
                                        href: "/visita/",
                                        children: [
                                            "Detalles de tu visita ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lsboS.default), {
                                                size: 18,
                                                "aria-hidden": "true"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                        className: "text-link text-link-light",
                                        href: (0, $gb7Gf.mapUrl),
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: [
                                            "Abrir en Google Maps ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03hdr.default), {
                                                size: 17,
                                                "aria-hidden": "true"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "visit-details reveal",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "visit-map",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                                    title: "Mapa de Iglesia Cristiana Tercer Cielo",
                                    src: (0, $gb7Gf.mapEmbedUrl),
                                    loading: "lazy",
                                    referrerPolicy: "no-referrer-when-downgrade",
                                    allowFullScreen: true
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                className: "visit-detail visit-detail-link",
                                href: (0, $gb7Gf.mapUrl),
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hipFw.default), {
                                            size: 21,
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                children: "Direcci\xf3n"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                children: (0, $gb7Gf.churchAddress).street
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: (0, $gb7Gf.churchAddress).locality
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03hdr.default), {
                                        className: "visit-detail-arrow",
                                        size: 18,
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $9aecac4636d85589$export$36d69433c4f81145() {
    const { status: status } = (0, $3ua1s.useEvents)();
    (0, $3ua1s.useReveal)(status);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5xqgC.Layout), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9aecac4636d85589$var$Hero, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($9aecac4636d85589$var$VerseStrip, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($9aecac4636d85589$var$ServicesSection, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($9aecac4636d85589$var$EventsSection, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($9aecac4636d85589$var$MinistriesSection, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($9aecac4636d85589$var$PastorsSection, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($9aecac4636d85589$var$GallerySection, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($9aecac4636d85589$var$SocialCtaSection, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($9aecac4636d85589$var$VisitSection, {})
        ]
    });
}



const $5937fc8f793dfe65$var$container = document.getElementById('app');
(0, $aRPiL.createRoot)($5937fc8f793dfe65$var$container).render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.StrictMode), {
    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9aecac4636d85589$export$36d69433c4f81145), {})
}));


//# sourceMappingURL=repo.0069f96a.js.map
